import React, { Fragment } from "react";
import { Button } from "../Button";
import { useTranslation } from "../hooks/useTranslation";
/** Form Button component
 * Encapsulates cancel, edit, and submit buttons.
 * Depending on which call back and viewState that
 * is passed in, the appropriate buttons with appropriate
 * labels will be passed in.
 */
export const FormButtons = ({ viewState, saveState, onCancel, onEdit, onSubmit, id, editDisabled, hideCancel = false, children, }) => {
    const t = useTranslation();
    return (React.createElement(Fragment, null,
        viewState === "edit" && (React.createElement(Fragment, null,
            !hideCancel && (React.createElement(Button, { label: onEdit ? t("Cancel") : t("Reset"), onClick: onCancel, disabled: saveState === "saving", id: id && `${id}__cancel`, dataHook: onEdit ? "cancel-button" : "reset-button" })),
            onSubmit ? (React.createElement(Button, { type: "primary", onClick: onSubmit, label: t("Save"), disabled: saveState === "saving", dataHook: "save-button" })) : (children))),
        viewState === "read" && (React.createElement(Button, { label: t("Edit"), type: "primary", onClick: onEdit, disabled: onEdit === undefined || editDisabled, id: id && `${id}__edit`, dataHook: "edit-button" }))));
};
